<snelstart-venture-fiscaal-feature-behandelkosten></snelstart-venture-fiscaal-feature-behandelkosten>

<snelstart-venture-fiscaal-feature-medicijnen></snelstart-venture-fiscaal-feature-medicijnen>

<snelstart-venture-fiscaal-feature-hulpmiddelen></snelstart-venture-fiscaal-feature-hulpmiddelen>

<snelstart-venture-fiscaal-feature-reiskosten-eigen-zorg></snelstart-venture-fiscaal-feature-reiskosten-eigen-zorg>

<snelstart-venture-fiscaal-feature-dieten></snelstart-venture-fiscaal-feature-dieten>

<snelstart-venture-fiscaal-feature-reiskosten-zorg-gezinslid></snelstart-venture-fiscaal-feature-reiskosten-zorg-gezinslid>

<snelstart-venture-fiscaal-feature-extra-uitgaven-kleding-en-beddengoed></snelstart-venture-fiscaal-feature-extra-uitgaven-kleding-en-beddengoed>

<snelstart-venture-fiscaal-feature-kosten-extra-gezinshulp></snelstart-venture-fiscaal-feature-kosten-extra-gezinshulp>

<div class="pt-3" style="width: 50%">
    <snelstart-ui-alert type="info">
        <span>De drempel voor aftrek zorgkosten bedraagt € {{ this.drempelZorgkosten | number: '1.0-0' }}.</span>
    </snelstart-ui-alert>
</div>

